export const INFO_LAB_REQUEST = "INFO_LAB_REQUEST";
export const INFO_LAB_SUCCESS = "INFO_LAB_SUCCESS";
export const INFO_LAB_FAIL = "INFO_LAB_FAIL";
